import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/module/carousel.css";

// import bg4 from "../../assets/images/img/bg-4.webp";

const slides = [
  {
    title: "Initial Assessment",
    desc: "We start by evaluating your existing website or goals for a new one. This includes understanding your brand, audience, and current performance.",
  },
  {
    title: "Planning and Setup",
    desc: "After assessment, we outline a clear action plan—defining updates, tools, timelines, and management strategies to keep your site effective.",
  },
  {
    title: "Design Refinement",
    desc: "We enhance the visual appeal and usability of your website through layout adjustments, UI improvements, and responsive design updates.",
  },
  {
    title: "Content & Technical Updates",
    desc: "Our team regularly updates website content, fixes bugs, improves performance, and ensures everything is optimized for speed and SEO.",
  },
  {
    title: "Monitoring and Testing",
    desc: "We continuously check for broken links, performance issues, and errors across devices to ensure the site works seamlessly for all users.",
  },
  {
    title: "Security & Backup",
    desc: "We implement strong security measures, perform regular backups, and stay updated on potential threats to keep your site safe and stable.",
  },
  {
    title: "Ongoing Support",
    desc: "As your business grows, we provide continued support—making improvements, adding features, and keeping the website aligned with your goals.",
  },
];

export default function WebMgmtSlider() {
  useScrollReveal("slide-from-left");
  useScrollReveal("drop-from-top");
  useScrollReveal("slide-from-bottom");
  const settings = {
    dots: true, // Show dots
    infinite: false, // Do not loop infinitely
    speed: 500, // Slide animation speed
    slidesToShow: 3, // Show 3 slides at once
    slidesToScroll: 1, // Scroll one slide at a time
    swipeToSlide: true, // Allow drag/swipe
    arrows: false, // Show arrows
    responsive: [
      // Responsive settings for smaller screens
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div id="karuzela" className="section section__carousel">
      {/* <img
        className="container-bg image-background left slide-from-left"
        src={bg4}
        alt="container background"
        style={{ marginTop: "400px" }}
      /> */}
      <div className="container carousel">
        <h5 className="drop-from-top">step by step</h5>
        <div className="title flex drop-from-top">
          <h2 style={{ marginBottom: 30 }}>
            What does the Website Management process look like?
          </h2>
        </div>

        <div className="carousel-slider slick-initialized slick-slider slick-dotted slide-from-bottom">
          <div className="slick-list draggable">
            <Slider {...settings}>
              {slides.map((slide, index) => (
                <div key={index} className="card" style={{ padding: 10 }}>
                  <div className="card-element">
                    <h6 className="title">{slide.title}</h6>
                    <span className="desc mini">{slide.desc}</span>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
}
